import { render, staticRenderFns } from "./hotspot-component.vue?vue&type=template&id=6dbb4504&scoped=true&"
import script from "./hotspot-component.vue?vue&type=script&lang=ts&"
export * from "./hotspot-component.vue?vue&type=script&lang=ts&"
import style0 from "./hotspot-component.vue?vue&type=style&index=0&id=6dbb4504&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbb4504",
  null
  
)

export default component.exports